import React from 'react';
import { Box, IconButton } from '@material-ui/core';
import { Close as CloseIcon, ErrorOutline as ErrorIcon } from '@material-ui/icons';

interface SubtleErrorNotificationProps {
  error?: Error | null;
  onDismiss: () => void;
}

const defaultProps = {
  error: null,
};

export const SubtleErrorNotification: React.FC<SubtleErrorNotificationProps> = ({ 
  error, 
  onDismiss 
}) => {
  if (!error) return null;

  return (
    <Box
      position="fixed"
      top={10}
      right={10}
      bgcolor="#ffebee"
      border="1px solid #f44336"
      borderRadius={1}
      p={1}
      maxWidth={320}
      fontSize={12}
      zIndex={9999}
      boxShadow="0 2px 8px rgba(0,0,0,0.15)"
      display="flex"
      alignItems="flex-start"
    >
      <ErrorIcon style={{ color: '#f44336', fontSize: 16, marginRight: 8, marginTop: 2 }} />
      <Box flex={1}>
        <Box color="#d32f2f" fontWeight="bold" mb={0.5}>
          Error detected
        </Box>
        <Box color="#666" fontSize={11} lineHeight={1.3}>
          App continues running. Error logged automatically.
        </Box>
        {process.env.NODE_ENV === 'development' && (
          <Box 
            mt={0.5} 
            p={0.5} 
            bgcolor="#f5f5f5" 
            borderRadius={0.5} 
            fontSize={10}
            fontFamily="monospace"
            color="#333"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            maxWidth={250}
            title={error.message}
          >
            {error.message}
          </Box>
        )}
      </Box>
      <IconButton 
        size="small" 
        onClick={onDismiss}
        style={{ 
          color: '#f44336',
          padding: 2
        }}
      >
        <CloseIcon style={{ fontSize: 14 }} />
      </IconButton>
    </Box>
  );
};

SubtleErrorNotification.defaultProps = defaultProps;

export default SubtleErrorNotification;